import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PrimaryLink from '../../../components/buttons/PrimaryLink'
import { Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import effects from 'app/effects/effects'
import DialogDeleteAllPhotos from '../components/DialogDeleteAllPhotos'
import UploadZone from '../components/UploadZone'
import { Photo } from '../components/Photo'
import { FormattedMessage } from 'react-intl'

const DELETE_DIALOG = 'DELETE_DIALOG'

// to do
const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#a8a8a8',
    marginTop: 67,
  },
  subtitle: {
    fontSize: 12,
    textAlign: 'center',
    color: '#404040',
    marginBottom: 30,
  },
  actionsHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  photosContainer: {
    margin: 'auto',
    width: 604,
    display: 'block',
    '@media (max-width: 690px)': {
      width: 350,
    },
  },
}))

export default () => {
  const initPageState = {
    isOpenDeleteDialog: false,
    deletedGroupId: null,
    deleteDialogMsg: '',
  }
  const [photos, setPhotos] = useState([])
  const [pageState, setPageState] = useState(initPageState)

  useEffect(() => {
    effects.apis.getPlacePhotos().then((images) => {
      setPhotos(images.data.filter((photo) => photo.source !== 'link'))
    })
  }, [])

  const deleteAction = (ids, filterIds = null) => {
    filterIds = filterIds || ids
    setPhotos(photos.filter((photo) => !filterIds.includes(photo.id)))
    return effects.apis.deletePhotos({
      ids,
    })
  }

  const deleteAll = () => {
    toggleDialogs(DELETE_DIALOG, true)
  }

  function toggleDialogs(dialogType, isOpen) {
    if (dialogType === DELETE_DIALOG) {
      setPageState({
        ...pageState,
        isOpenDeleteDialog: isOpen,
      })
    }
  }

  const handleDeleteGroups = async () => {
    const images = await effects.apis.getPlacePhotos()
    const allPhotos = images.data.map(({ id }) => id)
    await deleteAction(
      allPhotos,
      photos.map(({ id }) => id),
    )
    toggleDialogs(DELETE_DIALOG, false)
  }

  const onUploadPush = async (filesEncoded) => {
    const tempId = photos.length
    const filesToAdd = filesEncoded.map((fileEncoded, index) => ({
      id: tempId + index,
      source: 'manual',
      path: fileEncoded,
      percentage: 0,
      uploadStatus: 1,
    }))
    setPhotos([...photos, ...filesToAdd])
  }

  const classes = useStyles()

  return (
    <div>
      <div className={classes.title}>
        <FormattedMessage id="profile.info.date.manage.images" />
      </div>
      <div className={classes.subtitle}>
        <FormattedMessage id="profile.info.landing.select" />
      </div>
      <div className={classes.photosContainer}>
        {!!photos.length && (
          <div className="flex justify-end mr-6">
            <PrimaryLink
              onClick={() => deleteAll()}
              className={clsx(
                'ltr:mr-3 rtl:ml-3 underline font-bold flex items-center',
              )}
            >
              <Icon>delete</Icon>{' '}
              <FormattedMessage id="profile.info.delete.all" />
            </PrimaryLink>
          </div>
        )}
        <div>
          {photos.map((img, index) => (
            <Photo img={img} key={index} onDelete={deleteAction} />
          ))}
        </div>
      </div>
      <UploadZone onUploadPush={onUploadPush} />
      <DialogDeleteAllPhotos
        state={pageState}
        classes={classes}
        toggleDialogs={toggleDialogs}
        handleDeleteGroups={handleDeleteGroups}
        DELETE_DIALOG={DELETE_DIALOG}
      />
    </div>
  )
}
